document.addEventListener("DOMContentLoaded", function () {
	const accordionButtons = document.querySelectorAll(".accordion-button");
	const accordionContents = document.querySelectorAll(".accordion-content");

	// Set the first tab as active by default
	if (accordionButtons.length > 0) {
		accordionButtons[0].classList.add("!bg-[#424242]", "!text-[#ffffff]"); // Set active button styling
	}
	if (accordionContents.length > 0) {
		accordionContents[0].classList.remove("hidden");
		accordionContents[0].classList.add("block");

		// Initialize Slick for the first section on page load
		initSlickForAccordion(accordionContents[0]);
	}

	// Loop through all accordion buttons and add event listeners
	accordionButtons.forEach(function (button) {
		button.addEventListener("click", function () {
			// Remove 'active' class from all buttons
			accordionButtons.forEach(function (btn) {
				btn.classList.remove("!bg-[#424242]", "!text-[#ffffff]");
			});

			// Add 'active' class to the clicked button
			button.classList.add("!bg-[#424242]", "!text-[#ffffff]");

			// Hide all accordion content sections
			accordionContents.forEach(function (content) {
				content.classList.remove("block");
				content.classList.add("hidden");
			});

			// Show the corresponding accordion content
			const targetId = button.getAttribute("data-target");
			const targetContent = document.querySelector(targetId);
			if (targetContent) {
				targetContent.classList.remove("hidden");
				targetContent.classList.add("block");

				// Initialize Slick after the content is revealed
				initSlickForAccordion(targetContent);
			}
		});
	});

	// Function to initialize the Slick slider for each revealed accordion content
	function initSlickForAccordion(targetContent) {
		const $slider = $(targetContent).find(".cons-slider-alt");

		// Initialize slick only if it's not already initialized
		if ($slider.length && !$slider.hasClass("slick-initialized")) {
			$slider.slick({
				slidesToShow: 3,
				slidesToScroll: 3,
				arrows: false,
				dots: false,
				adaptiveHeight: true,
				speed: 900,
				cssEase: "cubic-bezier(0.77, 0, 0.175, 1)",
				infinite: false,
				responsive: [
					// {
					// 	breakpoint: 1500,
					// 	settings: { slidesToShow: 2, slidesToScroll: 2 },
					// },
					// {
					// 	breakpoint: 1400,
					// 	settings: { slidesToShow: 1, slidesToScroll: 1 },
					// },
					{
						breakpoint: 1024,
						settings: { slidesToShow: 1, slidesToScroll: 1 },
					},
					{ breakpoint: 768, settings: { slidesToShow: 1, slidesToScroll: 1 } },
					{ breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1 } },
				],
			});

			// Bind the custom arrows to the slick slider
			$(targetContent)
				.find(".slick-left")
				.on("click", function () {
					$slider.slick("slickPrev");
				});
			$(targetContent)
				.find(".slick-right")
				.on("click", function () {
					$slider.slick("slickNext");
				});
		} else {
			// Force resize if Slick is already initialized
			$slider.slick("setPosition");
		}
	}

	// FAQ
	const accordions = document.querySelectorAll(".accordion-area");

	accordions.forEach((accordion) => {
		const buttons = accordion.querySelectorAll(".faq-header button");

		buttons.forEach((button) => {
			const target = button.dataset.target;
			const collapse = accordion.querySelector(target);
			const icon = button.querySelector("i");

			// Ensure closed by default
			if (collapse) {
				collapse.style.maxHeight = "0px";
				collapse.style.overflow = "hidden";
			}

			button.addEventListener("click", () => {
				if (!collapse) return;

				const isOpen =
					collapse.style.maxHeight && collapse.style.maxHeight !== "0px";

				// Close all others
				buttons.forEach((otherButton) => {
					if (otherButton !== button) {
						const otherTarget = otherButton.dataset.target;
						const otherCollapse = accordion.querySelector(otherTarget);
						const otherIcon = otherButton.querySelector("i");

						if (otherCollapse) {
							otherCollapse.style.maxHeight = "0px";
						}
						if (otherIcon) {
							otherIcon.classList.remove("rotate-180");
						}
					}
				});

				// Toggle current
				if (isOpen) {
					collapse.style.maxHeight = "0px";
					icon?.classList.remove("rotate-180");
				} else {
					// Scroll FIRST to avoid bounce
					requestAnimationFrame(() => {
						const yOffset = -100;
						const y =
							accordion.getBoundingClientRect().top +
							window.pageYOffset +
							yOffset;

						window.scrollTo({
							top: y,
							behavior: "smooth",
						});
					});

					// THEN expand
					collapse.style.maxHeight = collapse.scrollHeight + "px";
					icon?.classList.add("rotate-180");
				}
			});
		});
	}); 
});

jQuery(document).ready(function ($) {
	const $block = $(".product-area-block");
	const $mainSlider = $block.find(".product-slider");
	const $thumbSlider = $block.find(".product-slider-thumbnails");

	// MAIN SLIDER
	$mainSlider.slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		dots: false,
		fade: true,
		asNavFor: $thumbSlider,
		adaptiveHeight: true,
	});

	// THUMBNAILS (VERTICAL)
	$thumbSlider.slick({
		slidesToShow: 5,
		slidesToScroll: 1,
		asNavFor: $mainSlider,
		focusOnSelect: true,
		arrows: true,
		vertical: true,
		verticalSwiping: true,
		infinite: false,
		responsive: [
			{
				breakpoint: 1023,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1,
					vertical: false,
					verticalSwiping: false,
				},
			},
		],
	});
});

jQuery(function ($) {
	// Apply WooCommerce fragments to update cart contents
	function applyWooFragments(fragments) {
		if (!fragments || typeof fragments !== "object") {
			return;
		}

		$.each(fragments, function (selector, html) {
			$(selector).replaceWith(html);
		});
	}

	// Make AJAX request for side cart operations (e.g., updating qty or removing items)
	function sideCartRequest(payload) {
		if (typeof wc_add_to_cart_params === "undefined") {
			return;
		}

		$.ajax({
			url: wc_add_to_cart_params.ajax_url,
			type: "POST",
			dataType: "json",
			data: payload,
			success: function (response) {
				if (!response || !response.success) {
					return;
				}

				const fragments = response.data.fragments || {};
				const cartHash = response.data.cart_hash || "";
				applyWooFragments(fragments);
				$(document.body).trigger("wc_fragments_refreshed");
				$(document.body).trigger("added_to_cart", [fragments, cartHash, null]);
			},
		});
	}

	// Open the side cart
	function openSideCart() {
		$("#custom-cart-popup").addClass("open");
		$("#custom-cart-backdrop").addClass("open");
		$("body").addClass("side-open");
	}

	// Close the side cart
	function closeSideCart() {
		$("#custom-cart-popup").removeClass("open");
		$("#custom-cart-backdrop").removeClass("open");
		$("body").removeClass("side-open");
	}

	// Open the side cart when an item is added
	$(document.body).on("added_to_cart", function (event, fragments) {
		applyWooFragments(fragments);

		// Prevent cart from opening on page load (if on the cart page)
		if ($("body").hasClass("woocommerce-cart")) {
			return;
		}

		openSideCart();
	});

	// Close the cart when the close button or backdrop is clicked
	$("body").on(
		"click",
		".custom-cart-close, #custom-cart-backdrop",
		function (e) {
			e.preventDefault();
			closeSideCart();
		},
	);

	// Handle AJAX submit for product form (add to cart)
	$("body").on("submit", ".product-area-block form.cart", function (e) {
		const $form = $(this);
		if ($form.data("cartSubmitting")) {
			e.preventDefault();
			e.stopImmediatePropagation();
			return false;
		}
		$form.data("cartSubmitting", true);
		const isVariableForm =
			$form.find('input[name="variation_id"]').length > 0 ||
			$form.find('select[name^="attribute_"]').length > 0;

		// Handle variable products via AJAX so side cart behavior matches simple products.
		if (isVariableForm) {
			const $button = $form.find('button[type="submit"]').first();
			if (typeof wc_add_to_cart_params === "undefined") {
				$form.data("cartSubmitting", false);
				return;
			}

			const formData = {};
			$form.serializeArray().forEach(function (field) {
				formData[field.name] = field.value;
			});

			if (!formData.product_id && formData["add-to-cart"]) {
				formData.product_id = formData["add-to-cart"];
			}
			if (!formData.product_id) {
				formData.product_id = $form.data("product_id");
			}
			if (!formData.quantity) {
				formData.quantity = 1;
			}

			const variationId = parseInt(formData.variation_id, 10) || 0;
			// If no variation is selected, let WooCommerce handle native validation/messages.
			if (!variationId) {
				$form.data("cartSubmitting", false);
				return;
			}

			e.preventDefault();
			const requestData =
				$form.serialize() + "&action=woocommerce_ajax_add_to_cart";

			$button.addClass("loading");

			$.ajax({
				url: wc_add_to_cart_params.ajax_url,
				type: "POST",
				dataType: "json",
				data: requestData,
				success: function (response) {
					if (!response || !response.success) {
						return;
					}

					const fragments = response.data.fragments || {};
					const cartHash = response.data.cart_hash || "";
					applyWooFragments(fragments);

					$(document.body).trigger("added_to_cart", [
						fragments,
						cartHash,
						$button,
					]);
				},
				complete: function () {
					$form.data("cartSubmitting", false);
					$button.removeClass("loading");
				},
			});

			return;
		}

		e.preventDefault();

		const $button = $form.find('button[type="submit"]').first();
		const productId =
			parseInt($form.find('input[name="add-to-cart"]').val(), 10) || 0;

		if (!productId || typeof wc_add_to_cart_params === "undefined") {
			$form.data("cartSubmitting", false);
			return;
		}

		$button.addClass("loading");
		const requestData =
			$form.serialize() + "&action=woocommerce_ajax_add_to_cart";

		$.ajax({
			url: wc_add_to_cart_params.ajax_url,
			type: "POST",
			dataType: "json",
			data: requestData,
			success: function (response) {
				if (!response || !response.success) {
					return;
				}

				const fragments = response.data.fragments || {};
				const cartHash = response.data.cart_hash || "";
				applyWooFragments(fragments);

				$(document.body).trigger("added_to_cart", [
					fragments,
					cartHash,
					$button,
				]);
			},
			complete: function () {
				$form.data("cartSubmitting", false);
				$button.removeClass("loading");
			},
		});
	});

	// Update item quantity in the side cart
	$("body").on("click", ".js-side-cart-qty", function (e) {
		e.preventDefault();

		const $btn = $(this);
		const cartItemKey = $btn.data("cart-item-key");
		const qtyAction = $btn.data("qty-action");

		if (!cartItemKey || !qtyAction) {
			return;
		}

		sideCartRequest({
			action: "plotit_side_cart_update_qty",
			cart_item_key: cartItemKey,
			qty_action: qtyAction,
		});
	});

	// Set item quantity directly from input field
	$("body").on("change", ".js-side-cart-qty-input", function () {
		const $input = $(this);
		const cartItemKey = $input.data("cart-item-key");
		const quantity = parseInt($input.val(), 10) || 1;

		if (!cartItemKey) {
			return;
		}

		sideCartRequest({
			action: "plotit_side_cart_update_qty",
			cart_item_key: cartItemKey,
			qty_action: "set",
			quantity: quantity,
		});
	});

	// Remove item from the side cart
	$("body").on("click", ".js-side-cart-remove", function (e) {
		e.preventDefault();

		const $btn = $(this);
		const cartItemKey = $btn.data("cart-item-key");

		if (!cartItemKey) {
			return;
		}

		sideCartRequest({
			action: "plotit_side_cart_remove_item",
			cart_item_key: cartItemKey,
		});
	});
});

//inner-faq-block
